import React, { createContext, useCallback, useMemo, useRef } from 'react';
import modalPreview from '../modal/preview';
const PictureContext = createContext(undefined);
export default PictureContext;
export const PictureProvider = (props) => {
    const { children, modalProps: contextModalProps } = props;
    const pictureList = useRef([]);
    const registerPicture = useCallback((index, pictureRef) => {
        if (pictureList.current[index] !== pictureRef) {
            pictureList.current[index] = pictureRef;
        }
    }, [pictureList]);
    const unRegisterPicture = useCallback((index, pictureRef) => {
        if (pictureList.current[index] === pictureRef) {
            pictureList.current[index] = undefined;
        }
    }, [pictureList]);
    const preview = useCallback((index, modalProps = contextModalProps) => {
        const originalList = pictureList.current;
        const list = originalList.filter((picture) => picture && picture.src);
        let defaultIndex = index;
        if (list.length !== originalList.length) {
            const currentImgSrc = originalList[index]?.src;
            defaultIndex = list.findIndex(({ src }) => src === currentImgSrc);
        }
        modalPreview({
            defaultIndex,
            list,
        }, modalProps);
    }, [pictureList]);
    const value = useMemo(() => ({
        registerPicture,
        unRegisterPicture,
        preview,
    }), [registerPicture, unRegisterPicture, preview]);
    return (React.createElement(PictureContext.Provider, { value: value }, children));
};
